<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <!-- <div
            class="tabElement stock active"
            @click="changeTab('stock')"
          >
            <span class="material-icons-sharp"> app_registration </span>Manquant sur conteneur
          </div> -->
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> app_registration </span>Manquant sur
          inventaire
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <!-- <div @click="addNewReturnStock" class="buttonAdd">
            <span> Enregistrer une reprise de stock </span>
          </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in inventoryMissedData"
                :key="item._id"
              >
                <td @click="editeInventoryMissedDataRow(item)">
                  {{ item.status }}
                </td>
                <td @click="editeInventoryMissedDataRow(item)">
                  {{ item.product ? item.product.name : "" }}
                </td>
                <td @click="editeInventoryMissedDataRow(item)">
                  {{ item.product ? item.product.type : "" }}
                </td>
                <td @click="editeInventoryMissedDataRow(item)">
                  {{ item.quantity }}
                </td>
                <td @click="editeInventoryMissedDataRow(item)">
                  {{ item.store ? item.store.name : "" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { mapActions, mapGetters } from "vuex";
// import moment from "moment";
export default {
  name: "pertProduit",
  components: {},
  data: () => ({
    isSelecteds: [],
    isSelectedAll: false,
    tableHeader: [
      "Statut",
      "Nom du Produit",
      "Produit type",
      "Quantité",
      "Magasin",
    ],
    tableHeaderConteneur: [
      "Désignation",
      "Type de conteneur",
      "Produit",
      "Contenue estimation quantité",
      "Magasin",
      "Observation",
    ],
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
  },
  computed: {
    ...mapGetters([
      //   "contratData",
      //   "blData",
      //   "conteneurData",
      "contenuerAllData",
      "returnStockData",
      "inventoryMissedData",
      //   "storeData",
    ]),
  },
  async mounted() {
    await this.getMissingInventory({});
  },
  methods: {
    ...mapActions([
      //   "getContrat",
      //   "getSupplier",
      //   "getContratDetails",
      //   "getBl",
      //   "getConteneur",
      "getConteneurAll",
      "getReturnToStock",
      "getCustomerList",
      "getStore",
      "getProduct",
      "getMissingInventory",
      //   "getTransitaire",
      //   "getStore",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async editeInventoryMissedDataRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.inventoryMissedData.length; i++) {
          this.inventoryMissedData[i].isSelected = false;
        }
        // console.log("--------------------------------", item);["Manquant", "Excédent"]
        item.isSelected = true;
        const value = {
          _id: item._id,
          modalType: "editeInventoryMissedDataRow",
          observation: item.observation,
          quantity: item.quantity,
          status: item.status,
          isSurPlus: item.isSurPlus == true ? 'Excédent' : 'Manquant',
          store: item.store ? item.store.name : "",
          productId: item.product ? item.product._id : "",
          productName: item.product ? item.product.name : "",
          imageLink: item.documents[0]
        };
        // console.log("--------------------------------", value);
        this.$emit("editeRowForDash", {
          name: "editeInventoryMissedDataRow",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)

      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeReturnStockRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.returnStockData.length; i++) {
          this.returnStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.returnStockData);
        await this.getProduct({});
        await this.getStore({});
        await this.getCustomerList({});
        const value = {
          _id: item._id,
          modalType: "editeReturnStockRowMagasin",
          product: item.product ? item.product.name : "",
          store: item.store ? item.store.name : "",
          customer: item.customer ? item.customer.name : "",
          quantity: item.quantity,
          amount: item.amount,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "editeReturnStockRowMagasin",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show",true)
      this.$emit("closeAllModal");
      if (tabName === "stock") {
        await this.getConteneurAll({
          alreadyInStock: "Oui",
          haveAcknowledgeReceiptDate: "Oui",
        });
      } else if (tabName === "contrat") {
        await this.getMissingInventory({});
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
    